// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_HAZ","cls2":"Configuration-cls2_ftR Configuration-cls1_HAZ"};